<style>
	.total-company-name{
		margin:1em 0 .5em 1em;
	}
	.total-company-date{
		margin:0.5em 1em;
	}
	.total-company-p{
		margin:0;
		margin-left:3em;
	}
	.total-company-p:last-child{
		margin-bottom: 1em;
	}
	.total-company-ul{
		float: left;
		width: 100%;
		margin-left: 5%;
	}
	.total-company-ul li{
		float: left;
		width: 50%;
		font-size: 16px;
	}
</style>
<template>
	<div>
		<transition name="totalSlide">
			<div class="billcount-detail-total" v-show="shown" @click="moveAni" style="background:#fff">
				<p class="total-company-name"><strong>{{totalSum.restaurant_name}}</strong></p>
				<p class="total-company-date">
					<span>订货日期：</span>
					{{totalSum.startDate}} 到 {{totalSum.endDate}}
				</p>
				<ul class="total-company-ul">
					<li>含税金额合计：{{sub_total_send}} 元</li>
					<li>非税金额合计：{{sub_total_send_nottax}} 元</li>
					<li>订货金额合计：{{sub_total}} 元</li>
					<li>收货金额合计：{{sub_total_recipient}} 元</li>
					<li>退货金额合计：{{return_sub_total}} 元</li>
				</ul>
			</div>
		</transition>
		<div class="edi-total-second" v-show="!shown" @click="getTotal">合计</div>
	</div>
</template>
<script>
export default {
	props: {
		filter: {},
		totalHref: String,
		name: String
	},
	data () {
		return {
			shown: false,
			billState: 0,
			sub_total_send: 0,
			sub_total_send_nottax: 0,
			bill_state: '',
			totalSum: {}
		}
	},
	methods: {
		close () {
			this.shown = false
		},
		getTotal () {
			var val = this.totalHref
			this.$http.post(val, this.filter).then((response) => {
				if (response.body.result) {
					this.shown = !this.shown
					this.totalSum = response.body.data
					this.billState = this.totalSum.details[0].bill_state
					window.console.log(typeof (this.billState))
					this.sub_total_send = this.totalSum.details[0].sub_total_send || 0// 发货金额合计
					this.sub_total_send_nottax = this.totalSum.details[0].sub_total_send_nottax || 0// 发货金额合计

					this.sub_total_recipient = this.totalSum.details[0].sub_total_recipient || 0// 收货金额合计
					this.sub_total = this.totalSum.details[0].sub_total || 0// 收货金额合计
					this.return_sub_total = this.totalSum.details[0].return_sub_total || 0// 收货金额合计
				}
			})
		},
		moveAni () {
			this.shown = !this.shown
		}
	}
}
</script>


// WEBPACK FOOTER //
// GetMoneyTotal.vue?0d5faf7c